import script from "./Popin.vue?vue&type=script&setup=true&lang=js"
export * from "./Popin.vue?vue&type=script&setup=true&lang=js"

import "./Popin.vue?vue&type=style&index=0&id=2d97ddfa&lang=stylus"

const __exports__ = script;

export default __exports__